var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Tag.module.scss';
var Tag = function (_a) {
    var text = _a.text, primary = _a.primary, danger = _a.danger, warning = _a.warning, yellow = _a.yellow, lightGreen = _a.lightGreen, className = _a.className, id = _a.id, dataId = _a.dataId;
    var classes = "".concat(primary ? styles.Primary : '', " ").concat(danger ? styles.Danger : '', " ").concat(warning ? styles.Warning : '', " ").concat(yellow ? styles.Yellow : '', " ").concat(lightGreen ? styles.LightGreen : '');
    return (_jsx("span", __assign({ id: id, className: "".concat(styles.Tag, " ").concat(classes, " ").concat(className ? className : ''), "data-testid": dataId }, { children: text })));
};
Tag.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    primary: PropTypes.bool,
    danger: PropTypes.bool,
    warning: PropTypes.bool,
    yellow: PropTypes.bool,
    lightGreen: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
export { Tag };
//# sourceMappingURL=Tag.js.map